<template>
  <div class="pedido-em-digitacao">
    <g-card class="card-pedido-em-digitacao" 
    margem="20px" 
    :expansivel="true" 
    :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Pedidos em Digitação </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza"
            altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="limparFiltro"
            />
            <g-button
            class="buscar-button-header-filtro"
            largura="150px"
            icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="15px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            v-on:acao="buscar"
            >
            BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="pedido-digitacao-conteudo espacamento-filtros">
          <div class="unidade">
            <div class="titulo-conteudo-filtros"> Unidade </div>
            <PDropDown
            v-model="formSearch.UnidadeId"
            :options="EmpresaArray"
            class="unidade-input input-label unidade"
            placeholder="TODAS"
            optionValue="id"
            optionLabel="nome"
            :filter="true"
            >
            </PDropDown>
          </div>

          <div class="cliente">
            <div class="titulo-conteudo-filtros"> Cliente </div>
            <!-- <VMultiSelect
            v-model="formSearch.CLienteId"
            :options="dataClientes"
            class="cliente-input input-label"
            placeholder="Selecione o cliente"
            :filter="true"
            optionValue="id"
            optionLabel="nomeFantasia"
            :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
            @filter="buscarClientes($event.value)"
            >
              <template #option="slotProps">
                <cliente-dropdown-item
                :dadosCliente="slotProps.option"
                ></cliente-dropdown-item>
              </template>
            </VMultiSelect> -->
            <cliente-dropdown
              class="cliente-input input-label"
              v-model="formSearch.ClienteId"
              :representanteId="formSearch.RepresentanteId"
              :empresaId="formSearch.UnidadeId"
            />
          </div>

          <div class="data-digitacao">
            <div class="titulo-conteudo-filtros"> Data de Digitação </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                class="data-digitacao-inicio-input input-label"
                v-model="formSearch.DataInicio"
                placeholderinput="Início"
                :dataPassadas="true"
                alturainput = "40px"
                largurainput = "100%"
                tamanhobotao = "35px"
                invertido
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                v-model="formSearch.DataFim"
                class="data-digitacao-termino-input input-label"
                placeholderinput="Término"
                :dataPassadas="true"
                alturainput = "40px"
                largurainput = "100%"
                tamanhobotao = "35px"
                invertido
                ></g-date-input>
              </div>
            </div>
          </div>

          <div class="buscar-button-filtro">
            <g-button
            class="buscar-button"
            largura="100%"
            icone="icone_lupa.svg"
            negritoTexto
            altura="35px"
            tamanhoIcone="15px"
            tamanhoTexto="15px"
            gap="10px"
            :sombreado="false"
            @click="buscar"
            >
            BUSCAR
            </g-button>
          </div>
        </div>
      </g-form>
    </g-card>

    <g-card paddingDefault="0 0em 1em" class="card-resultado" margem="20px" :expansivel="false" :temCabecalho="false">
      <div class="" v-if="mensagemvazio">
        <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg"/>
        <div class="texto-padrao-imagemfundo"> Verifique os filtros e click em buscar para exibir os resultados </div>
      </div>

      <div v-else-if="!mensagemvazio">
        <g-data-table
        TextoVazio="Nenhum Pedido Encontrado"
        Titulo="Pedidos em Digitação"
        altura="auto"
        :colunas="Colunas"
        :Paginacao="true"
        :valores="PedidoArray"
        :NumeroLinhas="100"
        :Filtros="Filtro"
        :FiltrosEspecificos = "true"
        :EscondeColunaBotao="false"
        :Excluivel="true"
        v-on:excluir="excluirPedidoDigitacao"
        v-on:duploClickLinha="abrePopup"
        :campoAgrupador="'empresaCliente'"
        :campoExibicaoGrupo="'empresaCliente'"
        ></g-data-table>
      </div>

      <div class="editar-pedido">
        <PDialog :showHeader="false" :closable="false" v-model:visible="popup" :modal="true" >
          <div class="conteudo-popup-edicao"> Deseja continuar a editar as informações do pedido? </div>
          <div class="editar-informacoes-pedido">
            <div class="botao-sim">
              <g-button tipo="cinza" largura="100%" negritoTexto @click="fechaPopup"> NÃO </g-button>
            </div>
            <div class="botao-nao">
              <g-button largura="100%" negritoTexto @click="modificar"> SIM </g-button>
            </div>
          </div>
        </PDialog>
      </div>
    </g-card>
    <PDialog
      :closable="false"
      v-model:visible="popupConfirmarExclusao"
    >
      <div class="popup-confirmacao-exclusao">
        <div class="mensagem-confirmacao">Deseja mesmo excluir esse pedido?</div>
        <div class="engloba-botoes-confirmacao">
          <g-button
            class="botao-confirmacao"
            tipo="amarelo"
            negritoTexto
            @click="confirmarExclusaoPedido"
          >SIM</g-button>

          <g-button
            class="botao-confirmacao"
            tipo="cinza"
            negritoTexto
            @click="popupConfirmarExclusao = false"
          >NÃO</g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>

<script>
import PedidoEmDigitacao from './PedidoEmDigitacao.js'
export default PedidoEmDigitacao
</script>

<style scoped>
.card-pedido-em-digitacao-header {
  display: flex;
  justify-content: space-between;
}

.card-pedido-em-digitacao-titulo {
  color: #4f2c19;
  text-align: left;
  font-weight: bold;
  align-self: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.header-icons-pedido {
  display: flex;
  justify-content: flex-end;
}

.titulo {
  color: #747474;
  text-align: left;
  font-size: 14px;
  font-family: 'Montserrat';
  font-weight: bold;
  padding: 5px 0;
}

.periodo-data-digitacao {
  color: #747474;
  font-family: 'Montserrat';
}

.card-resultado-content {
  display: flex;
  flex-direction: column;
}

.imagem-nenhuma-info {
  margin: 60px auto 20px auto;
  max-height: 500px;
}
.card-resultado-text {
  color: #4f2c19;
  text-align: center;
  font-family: 'MontSerrat';
}

.card-resultado-subtext {
  color: #4F4C4D;
  font-family: 'MontSerrat';
}

.input-label {
  width: 100%;
  margin-bottom: 15px;
}

.editar-pedido {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: repeat(2, auto);
  grid-row-gap: 2%;
}
.conteudo-popup-edicao {
  grid-area: 1 / 1 / 2 / 2;
  color: #4E4E4E;
  text-align: center;
  font-weight: 600;
  font-family: 'MontSerrat';
  margin-top: 25px;
  margin-bottom: 15px;
}
.editar-informacoes-pedido {
  grid-area: 2 / 1 / 3 / 2;
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: 100%;
  grid-column-gap: 5%;
}
.botao-sim { grid-area: 1 / 2 / 2 / 3; }
.botao-nao { grid-area: 1 / 1 / 2 / 2; } 
.engloba-botoes-confirmacao{
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  margin-top: .5rem;
}

.botao-confirmacao{
  width: 100px;
}

@media (min-width:310px) {
  .buscar-button-filtro-pedido {
      display: flex;
      justify-content: center;
      align-items: self-end;
      margin-top: 10%;
  }

.buscar-button-header {
  display: none;
}
.card-pedido-em-digitacao-titulo {
  font-size: 16px;
}

.data-digitacao-input {
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: 100%;
  grid-column-gap: 4%;
}
.data-digitacao-inicio { grid-area: 1 / 1 / 2 / 2; }
.periodo-data-digitacao { grid-area: 1 / 2 / 2 / 3; align-self: center; }
.data-digitacao-termino { grid-area: 1 / 3 / 2 / 4; }

.pedido-digitacao-conteudo {
  display: flex;
  flex-direction: column;
  margin: 20px 0;

}



.imagem-nenhuma-info {
  height: 15vh;
}
}

@media (min-width:368px) {
.card-pedido-em-digitacao-titulo {
  font-size: 18px;
}

.buscar-button-pedido {
    width: 100%;
}
}

@media (min-width:600px) {
.buscar-button-pedido {
  display: none;
}

.buscar-button-filtro-pedido{
  margin: 0;
}

.buscar-button-header {
  display: block;
  margin-left: 15px;
}

.card-pedido-em-digitacao-titulo {
  font-size: 20px;
}

.pedido-digitacao-conteudo {
  margin: 20px 20px 0 20px;
}

.imagem-nenhuma-info {
  height: 25vh;
}
}

@media (min-width:801px) {
.pedido-digitacao-conteudo {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 100%;
  grid-column-gap: 20px;
}

.cliente { grid-area: 1 / 2 / 2 / 3; }
.unidade { grid-area: 1 / 1 / 2 / 2; }
.data-digitacao { grid-area: 1 / 3 / 2 / 4; }
}

@media (min-width:1025px) {
.card-pedido-em-digitacao-titulo {
  font-size: 22px;
}

.pedido-digitacao-conteudo {
  grid-template-columns: repeat(2, 1fr) minmax(6em, 20em);
}

.imagem-nenhuma-info {
  height: 35vh;
}

.data-digitacao-input{
  grid-template-columns: 1fr 20px 1fr;
}
}
.data-digitacao {grid-area: 1 / 3 / 2 / 5;}

@media (min-width:1281px) {
.data-digitacao { width: 100%; }

.pedido-digitacao-conteudo {
  grid-template-columns: repeat(2, minmax(6em, 30em)) minmax(6em, 25em);
}
}

@media (min-width:1500px) {
.data-digitacao { width: 100%; }
}
</style>